module.exports = __webpack_public_path__ + "c7cea2dd00b31d4f9f51056cb7799212.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-20.png
// module id = 2224
// module chunks = 0